import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ServiceWorkerModule } from '@angular/service-worker';
// ui boosts
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTreeModule } from '@angular/cdk/tree';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ClipboardModule } from 'ngx-clipboard';

// Mtic3 App Modules
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import { UiLoginModule } from './ui-login/ui-login.module';
import { UiPartialModule } from './ui-partial/ui-partial.module';
import { UiHierarchyChatModule } from './ui-hierarchy-chat/ui-hierarchy-chat.module';

import { GraphModule } from './graph/graph.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularSplitModule } from 'angular-split';
import { UiWhitelabelEnsModule } from './ui-whitelabel-ens/ui-whitelabel-ens.module';
import { LangService } from './core/lang.service';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from 'src/environments/environment';


export const ngMarkDownOptions = {
  markedOptions: {
    provide: MarkedOptions,
    useValue: {
      gfm: true,
      tables: true,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    },
  },
};

// Factory function for APP_INITIALIZER - initialize translations
export function initializeTranslations(langService: LangService) {
  return (): Promise<void> => {
    return langService.initializeTranslations();
  };
}

// IMPORTANT
// Add your own project credentials to environments/*.ts

@NgModule({
    declarations: [
        AppComponent
    ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {
          provide: APP_INITIALIZER,
          useFactory: initializeTranslations,
          deps: [LangService],
          multi: true
        }
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        BrowserTransferStateModule,
        AppRoutingModule,
        HttpClientModule,

        CoreModule,
        UiPartialModule,
        UiLoginModule,
        UiHierarchyChatModule,
        UiWhitelabelEnsModule,

        BrowserAnimationsModule,
        MarkdownModule.forRoot(ngMarkDownOptions),
        AngularSplitModule.forRoot(),
        ClipboardModule,

        FullCalendarModule,
        DragDropModule,
        CdkTreeModule,
        FormsModule,
        ReactiveFormsModule,
        GraphModule,
        // firebase
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
    ],
    exports: [
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
